import { render, staticRenderFns } from "./HeaderBottom.vue?vue&type=template&id=c7b20cfa&scoped=true&"
import script from "./HeaderBottom.vue?vue&type=script&lang=js&"
export * from "./HeaderBottom.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBottom.vue?vue&type=style&index=0&id=c7b20cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b20cfa",
  null
  
)

export default component.exports